import React, { useState, useContext, useEffect } from 'react';
import AppContext from '../../../context/AppContext';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import axios from 'axios';
import '../../../assets/css/admin/auth/Login.css';

const Login = () => {

  const navigate = useNavigate();
  const { baseUrl, setLoggedInAdmin } = useContext(AppContext);

  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

 
  
 

  
  const adminAutoLogin = (adminEmail, adminPassword) => {
  };

  

  // ✅ FORM VALIDATION
  // const validateForm = () => {
  //   if (!email || !password) {
  //     setErrorMessage("Email and Password required");
  //     return false;
  //   }

  //   if (emailError || passwordError) {
  //     setErrorMessage("Please fix validation errors");
  //     return false;
  //   }

  //   setErrorMessage('');
  //   return true;
  // };

  // LOGIN
  const handleLogin = (e) => {
    console.log( email. password);
    e.preventDefault();


    setIsLoading(true);

    const formData = new FormData();
    formData.append('email', email);
    formData.append('password', password);

    axios.post(`${baseUrl}/admin/auth/adminlogin`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((response) => {

        if (response.data.success == true) {

          localStorage.setItem("adminEmail", email);
          localStorage.setItem("adminPassword", password);
          localStorage.setItem("adminData", JSON.stringify(response.data.admin));
          setLoggedInAdmin(response.data.admin);

          navigate("/admin/dashboard");

        } else {
          setErrorMessage(response.data.message || "Login failed");
        }

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage("Server error");
        setIsLoading(false);
      });
  };

  useEffect(() => {
    
    const adminEmail = localStorage.getItem('adminEmail');
    const adminPassword = localStorage.getItem('adminPassword');

    if (adminEmail != null && adminPassword !=null) {
      
      adminAutoLogin(adminEmail, adminPassword);
 }
 else {
      setIsLoading(false);
    }
 
     }, []);

  return (
    <div className="adminlogin-wrapper">
      <div className="adminlogin-background-overlay"></div>

      <Container className="adminlogin-container">
        <Row className="justify-content-center align-items-center adminlogin-row">
          <Col xs={12} md={8} lg={5}>
            <Card className="adminlogin-card">
              <Card.Body className="adminlogin-card-body">

                {/* BRAND */}
                <div className="adminlogin-brand-section">
                  <div className="adminlogin-logo-circle">
                    <span className="adminlogin-logo-text">E</span>
                  </div>
                  <h2 className="adminlogin-title">Welcome Back</h2>
                  <p className="adminlogin-subtitle">Sign in to your admin account</p>
                </div>

                {/* FORM */}
                <div className="adminlogin-form">

                  {/* EMAIL */}
                  <div className="adminlogin-form-group">
                    <label className="adminlogin-label">Email</label>
                    <div className="adminlogin-input-wrapper">
                      <input
                        className="adminlogin-input"
                        type="email"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                      <FaEnvelope className="adminlogin-input-icon" />
                    </div>
                    {emailError && <span className="adminlogin-error-text">{emailError}</span>}
                  </div>

                  {/* PASSWORD */}
                  <div className="adminlogin-form-group">
                    <label className="adminlogin-label">Password</label>
                    <div className="adminlogin-input-wrapper">
                      <input
                        className="adminlogin-input adminlogin-input-password"
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                      />
                      <FaLock className="adminlogin-input-icon" />

                      <button className="adminlogin-password-toggle" type="button" onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                    {passwordError && <span className="adminlogin-error-text">{passwordError}</span>}
                  </div>

                  
                  {errorMessage && <span className="adminlogin-error-text">{errorMessage}</span>}

                  
                  <button className="adminlogin-submit-btn" type="button" onClick={handleLogin} disabled={isLoading}>
                    {isLoading ? "Logging in..." : "Login"}
                  </button>

                </div>

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

    </div>
  );
};

export default Login;